import React, { FC, Fragment, useCallback } from 'react';

import { FilterRadioHidden } from 'Components/FilterRadioHidden';
import withErrorBoundary from 'HOC/ErrorBoundary';

const overrideStyles = { color: '#079DC0' };

interface Props {
  callback?: (e: any) => void;
  scheduledVisit?: any;
}

const ScheduleVisitWithMyInstitution: FC<Props> = (props: Props) => {
  const { callback, scheduledVisit } = props;

  return (
    <>
      <FilterRadioHidden
        label="Any"
        value="Any"
        overrideStyles={overrideStyles}
        selected={scheduledVisit === 'Any'}
        identifier="scheduledVisit"
        onClick={useCallback(callback, [scheduledVisit])}
      />
      <FilterRadioHidden
        label="Yes"
        value="Yes"
        overrideStyles={overrideStyles}
        selected={scheduledVisit === 'Yes'}
        identifier="scheduledVisit"
        onClick={useCallback(callback, [scheduledVisit])}
      />
      <FilterRadioHidden
        label="No"
        value="No"
        overrideStyles={overrideStyles}
        selected={scheduledVisit === 'No'}
        identifier="scheduledVisit"
        onClick={useCallback(callback, [scheduledVisit])}
      />
    </>
  );
};

ScheduleVisitWithMyInstitution.defaultProps = {
  callback: () => {},
  scheduledVisit: 'No',
};

export default withErrorBoundary(ScheduleVisitWithMyInstitution);
